import React from 'react';

import strings from '../../Localization/Localization';

import { Col, Row, Button, Card } from 'react-bootstrap';

import OneRowText from '../Basic/OneRowText';

class CreditCenterElement extends React.Component {

	static defaultProps = {
		creditPack: null,
		onClickAdd: () => null
	}

	priceFormat(price) {
    return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(price);
  }

	displayQuantityFree() {
		if(this.props.creditPack["quantity_free"] !== 0) {
			return (
				<div className="d-flex justify-content-center">
					<div>
						{strings.creditPack.creditCenter.creditPack.freePre}&nbsp;{this.props.creditPack["quantity_free"]}&nbsp;{strings.creditPack.creditCenter.creditPack.freePost}
					</div>
				</div>
			)
		}
		return (
			<div>&nbsp;</div>
		)
	}

	displaySeparator() {
		return (
			<div className="credit-center-credit-pack-separator">
			</div>
		)
	}

	displayName() {
		return (
			<div className="d-flex justify-content-center">
				<div>
					{this.props.creditPack.name}
				</div>
			</div>
		)
	}

	displayPrice() {
		return (
			<div className="d-flex justify-content-center">
				<h3>
					{this.priceFormat(this.props.creditPack.price)}/HT
				</h3>
			</div>
		)
	}

	displayButton() {
		return (
			<div className="d-flex justify-content-center">
				<Button variant="my-validated" className="credit-center-credit-pack-add" onClick={(event) => this.props.onClickAdd(this.props.creditPack, event)}>
					{strings.creditPack.creditCenter.creditPack.button}
				</Button>
			</div>
		)
	}

	displayCard() {
    return (
      <Card.Body className="credit-center-credit-card-body">
        <Row>
          <Col xs="auto">
            <div className="credit-center-credit-card-image-container">
							<div className="d-flex justify-content-center">
								<div className="credit-center-credit-card-amount">{this.props.creditPack.quantity}</div><i className="icon-kredits-icons"/>
							</div>
            </div>
          </Col>
          <Col>
            <b><OneRowText text={this.props.creditPack.name}/></b>
            <OneRowText text={<>&nbsp;</>}/>
						<OneRowText text={`${this.priceFormat(this.props.creditPack.price)} H.T.`}/>
            <div className="credit-center-credit-card-free-amount"><OneRowText text={this.props.creditPack["quantity_free"]>0?`${strings.creditPack.creditCenter.creditPack.freePre} ${this.props.creditPack["quantity_free"]} ${strings.creditPack.creditCenter.creditPack.freePost}`:""}/></div>
          </Col>
        </Row>
      </Card.Body>
    )
  }

  render() {
		return (
    	<Col xs={12} md={4} className="credit-center-credit-pack-container">
				{this.displayCard()}
			</Col>
    );
  }
}

export default CreditCenterElement;
